Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    }
});

Vue.directive('focus-select', {
    inserted: function (el) {
        el.select();
    }
});
